var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCatalog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1101_14576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 2.5H12.4999C12.0579 2.5 11.634 2.67559 11.3214 2.98816C11.0088 3.30072 10.8333 3.72464 10.8333 4.16667V14.1667C10.8333 15.0507 11.1844 15.8986 11.8096 16.5237C12.4347 17.1488 13.2825 17.5 14.1666 17.5C15.0506 17.5 15.8985 17.1488 16.5236 16.5237C17.1487 15.8986 17.4999 15.0507 17.4999 14.1667V4.16667C17.4999 3.72464 17.3243 3.30072 17.0118 2.98816C16.6992 2.67559 16.2753 2.5 15.8333 2.5Z",
    stroke: "#1D4B3E",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 6.12535L9.16664 4.45868C8.8541 4.14623 8.43025 3.9707 7.98831 3.9707C7.54637 3.9707 7.12252 4.14623 6.80998 4.45868L4.45331 6.81535C4.14086 7.12789 3.96533 7.55174 3.96533 7.99368C3.96533 8.43562 4.14086 8.85947 4.45331 9.17201L11.9533 16.672",
    stroke: "#1D4B3E",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.08333 10.833H4.16667C3.72464 10.833 3.30072 11.0086 2.98816 11.3212C2.67559 11.6337 2.5 12.0576 2.5 12.4997V15.833C2.5 16.275 2.67559 16.699 2.98816 17.0115C3.30072 17.3241 3.72464 17.4997 4.16667 17.4997H14.1667",
    stroke: "#1D4B3E",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 14.167V14.1753",
    stroke: "#1D4B3E",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1101_14576"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalog);
export default __webpack_public_path__ + "static/media/catalog.656b7ad9.svg";
export { ForwardRef as ReactComponent };